module.exports = __webpack_public_path__ + "img/arrow-right.9878d5f7.svg";